<!-- src/components/Family.vue -->
<template>
  <div>
    <h1 class="title">Family</h1>
    <div class="columns is-multiline">
      <div v-for="post in posts" :key="post.id" class="column is-four-quarter">
        <div class="card post-preview" @click="openModal(post)">
          <div class="card-content">
            <h2 class="title is-4">{{ post.title }}</h2>
            <p class="subtitle is-6">{{ post.excerpt }}</p>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal for Posts -->
    <div class="modal" v-if="isModalOpen" @click.self="closeModal">
      <div class="modal-content">
        <span class="close" @click="closeModal">&times;</span>
        <div v-if="currentPost">
          <h2>{{ currentPost.title }}</h2>
          <p>{{ currentPost.fullText }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FamilyPage',
  data() {
    return {
      posts: [
        { 
    id: 1, 
    title: 'Family Matters', 
    excerpt: 'An insightful look into the significance of family...', 
    fullText: 'Family is where your heart is, a place where love and support abound. It’s where we find comfort in times of need, and joy in moments of celebration. Family is about the people who choose to be a part of our lives and share in our experiences. It’s in these connections that we find our truest sense of belonging and warmth, making family not just a place but a feeling we carry in our hearts.' },
    { 
    id: 2, 
    title: 'Beloved?', 
    excerpt: 'The One who loves me the most...', 
    fullText: 'I seek my Beloved who is already woven through the quiet of my breath, and though I see only the shape of the world, I am blind to what is truest for I long to be taught the grammar of love by Love Himself. I ache to whisper that I love Him, only to find He is the very word on my tongue and the silence surrounding it. Though I cannot name the hour when the veil will thin and I will find what has never been lost, I lay before Him all that I am: this wild and weary heart, and the fragile, fierce devotion my poor soul has managed to master.'  }     

      ],
      isModalOpen: false,
      currentPost: null
    };
  },
  methods: {
    openModal(post) {
      this.currentPost = post;
      this.isModalOpen = true;
    },
    closeModal() {
      this.isModalOpen = false;
      this.currentPost = null;
    }
  }
}
</script>


<style scoped>
.title {
  font-size: 2rem;
  margin-bottom: 20px;
}

.post {
  margin-bottom: 20px;
}

.post-preview {
  cursor: pointer;
  border: 1px solid #ddd;
  padding: 10px;
  border-radius: 5px;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.post-preview:hover {
  transform: scale(1.02);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
}

.post-title {
  font-size: 1.5rem;
  margin-bottom: 10px;
}

.post-excerpt {
  font-size: 1rem;
  color: #666;
}

.modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  backdrop-filter: blur(5px);
  background-color: black;
}

.modal-content {
  position: relative;
  max-width: 80%;
  max-height: 80%;
  padding: 20px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  border-radius: 5px;
  animation: fadeIn 0.3s ease;
}

.modal-content h2 {
  margin-bottom: 20px;
}

.modal-content p {
  font-size: 1rem;
  line-height: 1.5;
}

.close {
  position: absolute;
  top: 10px;
  right: 10px;
  font-size: 24px;
  cursor: pointer;
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
</style>
